import DispatchConstants from 'app/shared/constants/DispatchConstants';
import LoadingConstants from 'app/shared/constants/LoadingConstants';

const initState = () => ({
    logs: [],
    loadingState: LoadingConstants.INITIAL,
    error: null,
    pageSize: null,
    hasMoreData: true,
});

const activityHistory = (state = initState(), action = {}) => {
    const { type, payload } = action;

    switch (type) {
        case DispatchConstants.USER_MANAGEMENT_ACTIVITY_HISTORY_INIT:
            return initState();
        case DispatchConstants.USER_MANAGEMENT_SET_ACTIVITY_HISTORY_LOADING_STATE:
            return {
                ...state,
                loadingState: payload.loadingState,
            };
        case DispatchConstants.USER_MANAGEMENT_SET_ACTIVITY_HISTORY_ERROR:
            return {
                ...state,
                loadingState: LoadingConstants.SUCCESS,
                error: payload.error,
                hasMoreData: false,
            };
        case DispatchConstants.USER_MANAGEMENT_SET_ACTIVITY_HISTORY:
            return {
                ...state,
                logs: state.logs.concat(payload.logs),
                loadingState: LoadingConstants.SUCCESS,
                pageSize: payload.pageSize,
                hasMoreData: payload.logs.length >= payload.pageSize,
            };
        default:
            return state;
    }
};

export default activityHistory;
